import React, { ReactElement, useState, useEffect } from "react";

// types
import { PollQuizType, PollMCQsType } from "../../../types";

// apis
import { fetchPollInfoById } from "../../../apis/firebase";
import MultipleChoice from "../multipleChoice/multipleChoice.component";

const Quiz = ({
  canEditAnswer,
  mcqs,
  question,
  randomize,
  markCorrectAnswer,
  showResults,
  type,
  sessionId,
  pollId,
  trackId,
  docId,
}: PollQuizType): ReactElement => {
  const [start, setIsStart] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [response, setIsResponse] = useState(false);
  const [complete, setIsComplete] = useState(false);
  const [result, setIsResult] = useState(false);
  const [mcqsList, setMcqsList] = useState([]);
  const [activeMCQ, setActiveMCQ] = useState<PollMCQsType>(null);
  const [submitedAnswers, setSubmittedAnswers] = useState();

  useEffect(() => {
    (async () => {
      if (mcqs && mcqs.length > 0) {
        setMcqsList(
          await Promise.all(
            mcqs.map(async (d) => ({
              ...(await fetchPollInfoById(d)),
              trackId,
              pollId,
              sessionId,
            }))
          )
        );
      }
    })();
  }, [mcqs]);

  const handleStart = () => {
    // TODO: handle randomize

    setActiveMCQ(mcqsList[0]);

    setIsStart(true);
  };

  const handleSubmit = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsResponse(true);
    }, 2000);
  };

  const handleNext = () => {
    const currentIndex = mcqsList.findIndex(
      (d) => d.pollId === activeMCQ.pollId
    );

    if (currentIndex + 1 <= mcqsList.length - 1) {
      setActiveMCQ(mcqsList[currentIndex + 1]);
    } else {
      handleComplete();
    }
  };

  const handleComplete = () => {
    setIsComplete(true);
  };

  return (
    <div className="tm__polls">
      {/* Loader - Start */}
      {loading && (
        <div className="tm__polls-loader d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {/* Loader - End */}

      {!start && !result && (
        <div className="tm__polls-body">
          <div className="d-flex flex-column align-items-center">
            <i className="bi bi-question-circle fs-1 text-primary"></i>
            <span>{question}</span>
          </div>
        </div>
      )}
      {/* Start - End */}

      {start && !complete && (
        <div className="tm__polls-body">
          {activeMCQ && (
            <MultipleChoice
              {...activeMCQ}
              submitCallBack={(payload) => {
                setSubmittedAnswers(payload);
                handleNext();
              }}
            />
          )}
        </div>
      )}

      {/* Response - End */}
      {complete && (
        <div className="tm__polls-body">
          {/* Complete - Start */}
          <div>
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-trophy fs-1 text-primary"></i>
              <strong>
                <span>Well done,&nbsp;</span>You finished 2<sup>nd</sup>
              </strong>
              <ul className="list-style-none d-flex m-0 p-0 fs-8">
                <li className="mx-1">
                  Correct answers: <strong>0/2</strong>
                </li>
                <li className="mx-1">
                  Voting time: <strong>0:10</strong>
                </li>
              </ul>
            </div>
            <div className="collapse" id="quizExpand">
              <div className="mt-2">
                <label className="fs-7">What do you think ?</label>
                <div
                  className="alert alert-success d-flex fs-7 py-1 px-2 m-0"
                  role="alert">
                  <i className="bi bi-check-circle text-success fs-7 me-1"></i>
                  Quiz Option 1
                </div>
                <div
                  className="alert alert-danger d-flex fs-7 py-1 px-2 m-0 mt-2"
                  role="alert">
                  <i className="bi bi-x-circle text-danger fs-7 me-1"></i>
                  Quiz Option 4
                </div>
              </div>
            </div>
          </div>
          {/* Complete - End */}
        </div>
      )}

      {!result && (
        <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
          {!start && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              onClick={() => {
                handleStart();
              }}>
              Start
            </button>
          )}

          {/* {!complete && start && (
            <div className="d-flex align-items-center justify-content-between w-100">
              <small className="fs-8 text-grey">
                Quiz (1/2)<span className="mx-2">|</span>0:10
              </small>
              {!response && (
                <button
                  type="button"
                  className="btn btn-primary btn-small"
                  onClick={() => {
                    handleSubmit();
                  }}>
                  Send
                </button>
              )}
              {response && (
                <button
                  type="button"
                  className="btn btn-primary btn-small"
                  onClick={() => {
                    handleComplete();
                  }}>
                  Next Question
                </button>
              )}
            </div>
          )} */}

          {/* {response && start && complete && (
            <button
              type="button"
              className="btn btn-primary btn-small"
              data-bs-toggle="collapse"
              data-bs-target="#quizExpand"
              aria-expanded="false"
              aria-controls="quizExpand">
              View Correct Answers
            </button>
          )} */}
        </div>
      )}
    </div>
  );
};

export default Quiz;
